import React from 'react';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'error' | 'inherit';
  edge?: 'start' | 'end' | false;
  children: React.ReactNode;
}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      size = 'medium',
      color = 'inherit',
      edge = false,
      className = '',
      children,
      disabled,
      ...props
    },
    ref
  ) => {
    const sizeClasses = {
      small: 'p-1',
      medium: 'p-2',
      large: 'p-3',
    };

    const colorClasses = {
      primary: 'text-primary hover:opacity-80',
      secondary: 'text-secondary hover:opacity-80',
      error: 'text-red-600 hover:opacity-80',
      inherit: 'text-text-secondary hover:opacity-80',
    };

    const edgeClasses = edge === 'start' ? '-ml-2' : edge === 'end' ? '-mr-2' : '';

    const classes = [
      'inline-flex items-center justify-center rounded-full transition-opacity duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2',
      sizeClasses[size],
      colorClasses[color],
      edgeClasses,
      disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
      className,
    ].filter(Boolean).join(' ');

    return (
      <button
        ref={ref}
        className={classes}
        disabled={disabled}
        type="button"
        {...props}
      >
        {children}
      </button>
    );
  }
);

IconButton.displayName = 'IconButton';

export default IconButton;
